import { render, staticRenderFns } from "./Frühling.vue?vue&type=template&id=48b4c0ae&"
import script from "./Frühling.vue?vue&type=script&lang=js&"
export * from "./Frühling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports